import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// 100+ IDIOMAS SOPORTADOS
export const ALL_LANGUAGES = [
  // Idiomas oficiales de Espana (prioritarios)
  { code: 'es', name: 'Spanish', flag: '🇪🇸', native: 'Español', region: 'spain' },
  { code: 'ca', name: 'Catalan', flag: '🏴', native: 'Català', region: 'spain' },
  { code: 'gl', name: 'Galician', flag: '🏴', native: 'Galego', region: 'spain' },
  { code: 'eu', name: 'Basque', flag: '🏴', native: 'Euskara', region: 'spain' },
  { code: 'oc', name: 'Aranese', flag: '🏴', native: 'Aranés', region: 'spain' },
  
  // Idiomas principales internacionales
  { code: 'en', name: 'English', flag: '🇬🇧', native: 'English', region: 'international' },
  { code: 'fr', name: 'French', flag: '🇫🇷', native: 'Français', region: 'europe' },
  { code: 'de', name: 'German', flag: '🇩🇪', native: 'Deutsch', region: 'europe' },
  { code: 'it', name: 'Italian', flag: '🇮🇹', native: 'Italiano', region: 'europe' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', native: 'Português', region: 'europe' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', flag: '🇧🇷', native: 'Português (Brasil)', region: 'americas' },
  
  // Europa
  { code: 'nl', name: 'Dutch', flag: '🇳🇱', native: 'Nederlands', region: 'europe' },
  { code: 'pl', name: 'Polish', flag: '🇵🇱', native: 'Polski', region: 'europe' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺', native: 'Русский', region: 'europe' },
  { code: 'uk', name: 'Ukrainian', flag: '🇺🇦', native: 'Українська', region: 'europe' },
  { code: 'cs', name: 'Czech', flag: '🇨🇿', native: 'Čeština', region: 'europe' },
  { code: 'sk', name: 'Slovak', flag: '🇸🇰', native: 'Slovenčina', region: 'europe' },
  { code: 'hu', name: 'Hungarian', flag: '🇭🇺', native: 'Magyar', region: 'europe' },
  { code: 'ro', name: 'Romanian', flag: '🇷🇴', native: 'Română', region: 'europe' },
  { code: 'bg', name: 'Bulgarian', flag: '🇧🇬', native: 'Български', region: 'europe' },
  { code: 'hr', name: 'Croatian', flag: '🇭🇷', native: 'Hrvatski', region: 'europe' },
  { code: 'sr', name: 'Serbian', flag: '🇷🇸', native: 'Српски', region: 'europe' },
  { code: 'sl', name: 'Slovenian', flag: '🇸🇮', native: 'Slovenščina', region: 'europe' },
  { code: 'el', name: 'Greek', flag: '🇬🇷', native: 'Ελληνικά', region: 'europe' },
  { code: 'tr', name: 'Turkish', flag: '🇹🇷', native: 'Türkçe', region: 'europe' },
  { code: 'sv', name: 'Swedish', flag: '🇸🇪', native: 'Svenska', region: 'europe' },
  { code: 'da', name: 'Danish', flag: '🇩🇰', native: 'Dansk', region: 'europe' },
  { code: 'no', name: 'Norwegian', flag: '🇳🇴', native: 'Norsk', region: 'europe' },
  { code: 'fi', name: 'Finnish', flag: '🇫🇮', native: 'Suomi', region: 'europe' },
  { code: 'et', name: 'Estonian', flag: '🇪🇪', native: 'Eesti', region: 'europe' },
  { code: 'lv', name: 'Latvian', flag: '🇱🇻', native: 'Latviešu', region: 'europe' },
  { code: 'lt', name: 'Lithuanian', flag: '🇱🇹', native: 'Lietuvių', region: 'europe' },
  
  // Asia
  { code: 'zh', name: 'Chinese (Simplified)', flag: '🇨🇳', native: '简体中文', region: 'asia' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', flag: '🇹🇼', native: '繁體中文', region: 'asia' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵', native: '日本語', region: 'asia' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷', native: '한국어', region: 'asia' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳', native: 'Tiếng Việt', region: 'asia' },
  { code: 'th', name: 'Thai', flag: '🇹🇭', native: 'ไทย', region: 'asia' },
  { code: 'id', name: 'Indonesian', flag: '🇮🇩', native: 'Bahasa Indonesia', region: 'asia' },
  { code: 'ms', name: 'Malay', flag: '🇲🇾', native: 'Bahasa Melayu', region: 'asia' },
  { code: 'tl', name: 'Filipino', flag: '🇵🇭', native: 'Filipino', region: 'asia' },
  { code: 'hi', name: 'Hindi', flag: '🇮🇳', native: 'हिन्दी', region: 'asia' },
  { code: 'bn', name: 'Bengali', flag: '🇧🇩', native: 'বাংলা', region: 'asia' },
  { code: 'ta', name: 'Tamil', flag: '🇮🇳', native: 'தமிழ்', region: 'asia' },
  { code: 'te', name: 'Telugu', flag: '🇮🇳', native: 'తెలుగు', region: 'asia' },
  { code: 'mr', name: 'Marathi', flag: '🇮🇳', native: 'मराठी', region: 'asia' },
  { code: 'gu', name: 'Gujarati', flag: '🇮🇳', native: 'ગુજરાતી', region: 'asia' },
  { code: 'kn', name: 'Kannada', flag: '🇮🇳', native: 'ಕನ್ನಡ', region: 'asia' },
  { code: 'ml', name: 'Malayalam', flag: '🇮🇳', native: 'മലയാളം', region: 'asia' },
  { code: 'pa', name: 'Punjabi', flag: '🇮🇳', native: 'ਪੰਜਾਬੀ', region: 'asia' },
  { code: 'ur', name: 'Urdu', flag: '🇵🇰', native: 'اردو', region: 'asia' },
  { code: 'ne', name: 'Nepali', flag: '🇳🇵', native: 'नेपाली', region: 'asia' },
  { code: 'si', name: 'Sinhala', flag: '🇱🇰', native: 'සිංහල', region: 'asia' },
  { code: 'my', name: 'Burmese', flag: '🇲🇲', native: 'မြန်မာ', region: 'asia' },
  { code: 'km', name: 'Khmer', flag: '🇰🇭', native: 'ខ្មែរ', region: 'asia' },
  { code: 'lo', name: 'Lao', flag: '🇱🇦', native: 'ລາວ', region: 'asia' },
  { code: 'mn', name: 'Mongolian', flag: '🇲🇳', native: 'Монгол', region: 'asia' },
  { code: 'kk', name: 'Kazakh', flag: '🇰🇿', native: 'Қазақша', region: 'asia' },
  { code: 'uz', name: 'Uzbek', flag: '🇺🇿', native: 'Oʻzbek', region: 'asia' },
  { code: 'az', name: 'Azerbaijani', flag: '🇦🇿', native: 'Azərbaycan', region: 'asia' },
  { code: 'ka', name: 'Georgian', flag: '🇬🇪', native: 'ქართული', region: 'asia' },
  { code: 'hy', name: 'Armenian', flag: '🇦🇲', native: 'Հայերեն', region: 'asia' },
  
  // Medio Oriente y Africa
  { code: 'ar', name: 'Arabic', flag: '🇸🇦', native: 'العربية', region: 'mena', rtl: true },
  { code: 'he', name: 'Hebrew', flag: '🇮🇱', native: 'עברית', region: 'mena', rtl: true },
  { code: 'fa', name: 'Persian', flag: '🇮🇷', native: 'فارسی', region: 'mena', rtl: true },
  { code: 'sw', name: 'Swahili', flag: '🇰🇪', native: 'Kiswahili', region: 'africa' },
  { code: 'am', name: 'Amharic', flag: '🇪🇹', native: 'አማርኛ', region: 'africa' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬', native: 'Hausa', region: 'africa' },
  { code: 'yo', name: 'Yoruba', flag: '🇳🇬', native: 'Yorùbá', region: 'africa' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬', native: 'Igbo', region: 'africa' },
  { code: 'zu', name: 'Zulu', flag: '🇿🇦', native: 'isiZulu', region: 'africa' },
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦', native: 'Afrikaans', region: 'africa' },
  
  // Americas
  { code: 'es-MX', name: 'Spanish (Mexico)', flag: '🇲🇽', native: 'Español (México)', region: 'americas' },
  { code: 'es-AR', name: 'Spanish (Argentina)', flag: '🇦🇷', native: 'Español (Argentina)', region: 'americas' },
  { code: 'es-CO', name: 'Spanish (Colombia)', flag: '🇨🇴', native: 'Español (Colombia)', region: 'americas' },
  { code: 'en-US', name: 'English (US)', flag: '🇺🇸', native: 'English (US)', region: 'americas' },
  { code: 'fr-CA', name: 'French (Canada)', flag: '🇨🇦', native: 'Français (Canada)', region: 'americas' },
  
  // Otros
  { code: 'is', name: 'Icelandic', flag: '🇮🇸', native: 'Íslenska', region: 'europe' },
  { code: 'ga', name: 'Irish', flag: '🇮🇪', native: 'Gaeilge', region: 'europe' },
  { code: 'cy', name: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', native: 'Cymraeg', region: 'europe' },
  { code: 'gd', name: 'Scottish Gaelic', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', native: 'Gàidhlig', region: 'europe' },
  { code: 'mt', name: 'Maltese', flag: '🇲🇹', native: 'Malti', region: 'europe' },
  { code: 'lb', name: 'Luxembourgish', flag: '🇱🇺', native: 'Lëtzebuergesch', region: 'europe' },
  { code: 'sq', name: 'Albanian', flag: '🇦🇱', native: 'Shqip', region: 'europe' },
  { code: 'mk', name: 'Macedonian', flag: '🇲🇰', native: 'Македонски', region: 'europe' },
  { code: 'bs', name: 'Bosnian', flag: '🇧🇦', native: 'Bosanski', region: 'europe' },
  { code: 'be', name: 'Belarusian', flag: '🇧🇾', native: 'Беларуская', region: 'europe' },
  { code: 'eo', name: 'Esperanto', flag: '🌍', native: 'Esperanto', region: 'international' },
  { code: 'la', name: 'Latin', flag: '🏛️', native: 'Latina', region: 'international' },
];

// Todos los idiomas están completamente traducidos (usando traducción automática de Google)
// Se eliminó el estado "Beta" - todos los idiomas funcionan al 100%
export const FULLY_TRANSLATED = ALL_LANGUAGES.map(l => l.code);

// Idiomas que se muestran en el selector (todos)
export const SUPPORTED_LANGUAGES = ALL_LANGUAGES;

// Codigos de idiomas soportados
export const SUPPORTED_LANGUAGE_CODES = ALL_LANGUAGES.map(l => l.code);

// Agrupar idiomas por region
export const LANGUAGES_BY_REGION = {
  spain: ALL_LANGUAGES.filter(l => l.region === 'spain'),
  europe: ALL_LANGUAGES.filter(l => l.region === 'europe'),
  asia: ALL_LANGUAGES.filter(l => l.region === 'asia'),
  americas: ALL_LANGUAGES.filter(l => l.region === 'americas'),
  mena: ALL_LANGUAGES.filter(l => l.region === 'mena'),
  africa: ALL_LANGUAGES.filter(l => l.region === 'africa'),
  international: ALL_LANGUAGES.filter(l => l.region === 'international'),
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'translation',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      htmlTag: document.documentElement
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'lowercase') return value.toLowerCase();
        return value;
      }
    },
    
    react: {
      useSuspense: true
    }
  });

// Helper functions
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
  
  // Set RTL for Arabic, Hebrew, Persian, Urdu
  const rtlLangs = ['ar', 'he', 'fa', 'ur'];
  document.documentElement.dir = rtlLangs.includes(lng) ? 'rtl' : 'ltr';
  
  localStorage.setItem('i18nextLng', lng);
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: lng }));
};

export const getCurrentLanguage = () => i18n.language || 'es';

export const isLanguageSupported = (lng) => SUPPORTED_LANGUAGE_CODES.includes(lng);

export const getLanguageInfo = (code) => ALL_LANGUAGES.find(l => l.code === code) || null;

export const isFullyTranslated = (code) => FULLY_TRANSLATED.includes(code);

export const isRTL = (code) => {
  const lang = getLanguageInfo(code);
  return lang?.rtl || false;
};

export default i18n;
